/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Category_FieldInputs */

const en_admin_posts_category_field = /** @type {(inputs: Admin_Posts_Category_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category`)
};

const zh_admin_posts_category_field = /** @type {(inputs: Admin_Posts_Category_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分类`)
};

/**
* | output |
* | --- |
* | "Category" |
*
* @param {Admin_Posts_Category_FieldInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_posts_category_field = /** @type {((inputs?: Admin_Posts_Category_FieldInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Category_FieldInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_posts_category_field(inputs)
	return zh_admin_posts_category_field(inputs)
});
export { admin_posts_category_field as "admin.posts.category_field" }